<template>
    <div class="copy-file dialog-wraper">
        <tree @checked="checked"></tree>
        <div class="dialog-foot">
            <el-button @click="close" size="mini" v-t="'Cancel'"></el-button><el-button :loading="doing" type="primary" @click="onConfirm" size="mini" v-t="'Confirm'"></el-button>
        </div>
        
    </div>
</template>

<script>
import { mapActions, mapState,mapMutations} from "vuex";
import Tree from '@/components/dialog/file/Tree'

export default {
    data(){
        return {
            target_parentid: 0,
            target_groupid: 0
        }
    },
    components:{
        Tree
    },
    created(){

    },
    computed:{
        ...mapState([
            'dialogData'
        ]),
        ...mapState('index',[
            'doing'
        ])
    },
    methods:{
        ...mapActions('index',[
            'copy'
        ]),
        ...mapActions([
            'close'
        ]),
        checked(e){
            this.target_parentid = e.fname ? e.id : 0
            this.target_groupid = e.groupid || e.id
        },
        onConfirm(){
            let {groupid,fileid} = this.dialogData
            let {target_parentid,target_groupid} = this
            let data = {
                target_parentid,
                target_groupid,
                fileid,
                groupid
            }
            this.copy(data)
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/dialog/file/Copy.vue